import React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { RootState } from "redux/store";
import * as kestrelEmbedCode from "shared/kestrel-embed-code";
import * as yup from "yup";
import { validate } from "shared/yup";
import { WidgetConfigLayout } from "../widget-config-layout";
import { WidgetFieldGrid, WidgetFieldCell, WidgetSelect } from "../widget-fields";
import { getUser } from "redux/selector";

const mapStateToProps = (state: RootState) => {
	return {
		user: getUser(state),
	};
};

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
}, dispatch);

interface Props extends 
	ReturnType<typeof mapStateToProps>,
	ReturnType<typeof mapDispatchToProps> {
}

interface State {
	style: string;
}

class Component extends React.Component<Props, State> {

	public constructor(props: Props) {
		super(props) 
		this.state = {
			style: "",
		}
	}

	private validationSchema = {
		style: yup
			.string()
			.required("Style is required.")
	};

	public render() {
		const { user } = this.props;
		const { style } = this.state;
		const errors = validate(this.validationSchema, this.state);
		const embedCode = kestrelEmbedCode.loginWidget(
			user.websitePlatform,
			style,
		);
		return (
			<WidgetConfigLayout user={user} embedCode={!errors ? embedCode : undefined}>
				<WidgetFieldGrid>
					<WidgetFieldCell full>
						<WidgetSelect
							label="Style"
							required
							value={style}
							options={[{value: "vertical", label: "Vertical"}, {value: "twoline", label: "Two Line"}]}
							onChange={(value) => this.setState({style: value})}
						/>
					</WidgetFieldCell>
				</WidgetFieldGrid>
			</WidgetConfigLayout>
		);
	}
}

export const LoginConfig = connect(mapStateToProps, mapDispatchToProps)(Component);